/**
 * Legacy event records for 5 events
 * Add your event data here
 */

import { LegacyEventData } from './LegacyEventData';

// Template - replace with actual data
export const LegacyEvents2025Records: LegacyEventData[] = [
  // Event 1: WSG INTA Cocktail 2025 (example from user)
  {
    meetingDetails: {
      MeetingID: 2762,
      MType: "Cocktail Reception",
      MLocation: "Buchalter Office",
      MAddress: "655 W. Broadway",
      MAddress2: "Suite 1600",
      MCity: "San Diego",
      MState: "California",
      MZip: "92101",
      MCountry: "United States of America",
      datefrom: "2025-05-20 17:00:00",
      dateTo: "2025-05-20 19:00:00",
      MDescription: "World Services Group and host firm Buchalter welcomed members to the WSG INTA Networking Cocktail 2025 in San Diego, California USA. WSG members who attended the 2025 International Trademark Association Annual Meeting and those in the region had the opportunity to network and strengthen relationships at this networking cocktail reception.",
      MTitle: "WSG INTA Cocktail 2025",
      TimeZone: null,
      SetupType: null,
      Region: null,
      EventType: "In-Person",
      VenueLink: "https://www.google.com/maps/place/655+W+Broadway+UNIT+1600,+San+Diego,+CA+92101/@32.7153169,-117.171",
      BannerUpcomingURL: "2762sBanner.gif",
      BannerHomePageURL: "2762Bannerhome.gif",
      Emailbanner: "2762_emailbanner.jpg",
      OverviewTabDescription: "World Services Group and host firm Buchalter welcomed members to the WSG INTA Networking Cocktail 2025 in San Diego, California USA. WSG members who attended the 2025 International Trademark Association Annual Meeting and those in the region had the opportunity to network and strengthen relationships at this networking cocktail reception.",
      UpcomingEventPage: 1,
      ComingSoon: 0,
      ComingSoonMessage: "Date Coming Soon",
      LocationComingSoon: 0,
      LocationComingSoonMessage: "Location Coming Soon",
      IsHome: 1,
      IsDeleted: 0,
    },
    registrationSettings: {
      recid: 670,
      rmeetid: 2762,
      rprice1: 75.00,
      dateendregular: "2025-05-20 00:00:00",
      datebeginlate: "2025-05-21 00:00:00",
      RegTerms: "To transfer a registration to another person in your firm, please contact events@worldservicesgroup.com. Cancellations made after 20 April 2025 and on/before 5 May 2025 will be subject to a 30% cancellation fee. Cancellations made 6 May 2025 and thereafter are subject to the total cost (100%) of the registration fee.",
      Currency: "USD",
      CancelStartDate: "2025-04-21 00:00:00",
      CancelEndDate: "2025-05-05 00:00:00",
      RefundPercent: 70,
      RegistrationMessage: "Thank you for registering to attend WSG INTA Cocktail 2025\nPayment Pending. An email will be sent with payment information.",
      HasWaitList: 0,
      ExpirationDate: "2025-05-20",
      HasExpirationDate: 1,
    },
  },
  // Event 2: WSG European Meeting 2025
  {
    meetingDetails: {
      MeetingID: 2754,
      MType: "Regional Meeting",
      MLocation: "Belgium",
      MAddress: null,
      MAddress2: null,
      MCity: "Brussels",
      MState: null,
      MZip: null,
      MCountry: "Belgium",
      datefrom: "2025-04-02 09:00:00",
      dateTo: "2025-04-04 18:00:00",
      MDescription:
        "Altius Tiberghien hosted the WSG European Meeting 2025 in Brussels, Belgium. The program featured expert guest speakers, panels and interactive discussions, and offered great opportunities to network with colleagues in the region and globally.",
      MTitle: "WSG European Meeting 2025",
      TimeZone: "(UTC +0200) Europe/Brussels",
      SetupType: "Regional Meeting",
      Region: null,
      EventType: "In-Person",
      VenueLink: "Belgium",
      bannerURL: "2754Banner.gif",
      BannerUpcomingURL: "2754sBanner.gif",
      BannerHomePageURL: "2754Bannerhome.gif",
      Emailbanner: "2754_emailbanner.jpg",
      OverviewTabDescription:
        "Altius Tiberghien hosted the WSG European Meeting 2025 in Brussels, Belgium. The program featured expert guest speakers, panels and interactive discussions, and offered great opportunities to network with colleagues in the region and globally.",
      UpcomingEventPage: 1,
      ComingSoon: 0,
      ComingSoonMessage: "Date Coming Soon",
      LocationComingSoon: 0,
      LocationComingSoonMessage: "Location Coming Soon",
      IsHome: 1,
      IsDeleted: 0,
    },
    registrationSettings: {
      recid: 662,
      rmeetid: 2754,
      rprice1: 500.0,
      rprice2: 0.0,
      rprice3: 600.0,
      rprice4: 0.0,
      dateendregular: "2025-03-03 00:00:00",
      datebeginlate: "2025-03-04 00:00:00",
      RegTerms:
        "Cancellations made after 17 February 2025 and on/before 3 March will be subject to a 30% cancellation fee. Cancellations made 4 March 2025 and thereafter are subject to the total cost (100%) of the registrations fee. To transfer a registration to another person in your firm, please contact events@worldservicesgroup.com",
      Currency: "USD",
      CancelStartDate: "2025-02-24 00:00:00",
      CancelEndDate: "2025-03-03 00:00:00",
      RefundPercent: 30,
      RegistrationMessage:
        "Thank you for registering to attend WSG European Meeting 2025\nPayment Pending. An email will be sent with payment information.",
      HasWaitList: 0,
      ExpirationDate: "2025-04-02",
      HasExpirationDate: 1,
    },
    meetingHosts: [{ wsgCompaniesID: 10066, HostType: 1 }],
  },
  // Event 3: WSG Americas Meeting 2025
  {
    meetingDetails: {
      MeetingID: 2755,
      MType: "Regional Meeting",
      MLocation: "Grand Hyatt Atlanta in Buckhead",
      MAddress: "3300 Peachtree Road NE",
      MAddress2: null,
      MCity: "Atlanta",
      MState: "Georgia",
      MZip: "30305",
      MCountry: "United States of America",
      datefrom: "2025-05-07 23:00:00",
      dateTo: "2025-05-09 18:00:00",
      MDescription:
        "Morris, Manning, & Martin, LLP and Carey hosted the WSG Americas Meeting 2025 in Atlanta, Georgia. The program featured expert guest speakers, panels and interactive discussions, and offered great opportunities to network with colleagues in the region and globally.",
      MTitle: "WSG Americas Meeting 2025",
      TimeZone: "(UTC -0600) America/Houston",
      SetupType: "Regional Meeting",
      Region: null,
      EventType: "In-Person",
      VenueLink: "https://www.hyatt.com/en-US/group-booking/ATLGH/G-WSGA",
      bannerURL: "2755Banner.gif",
      BannerUpcomingURL: "2755sBanner.gif",
      BannerHomePageURL: "2755Bannerhome.gif",
      Emailbanner: "2755_emailbanner.jpg",
      OverviewTabDescription:
        "Morris, Manning, & Martin, LLP and Carey hosted the WSG Americas Meeting 2025 in Atlanta, Georgia. The program featured expert guest speakers, panels and interactive discussions, and offered great opportunities to network with colleagues in the region and globally.",
      UpcomingEventPage: 1,
      ComingSoon: 0,
      ComingSoonMessage: "Date Coming Soon",
      LocationComingSoon: 0,
      LocationComingSoonMessage: "Location Coming Soon",
      IsHome: 1,
      IsDeleted: 0,
      // Hotel from wsgMeetingHotel
      MHotelName: "Grand Hyatt Atlanta in Buckhead",
      MHotelAddress:
        "3300 Peachtree Road NE, Atlanta, GA 30305 United States of America",
      MHotelText:
        "The Grand Hyatt Buckhead hotel near downtown Atlanta places you in the center of this iconic neighborhood—home to remarkable architecture, exceptional restaurants, multiple shopping centers and the financial district. Discover everything that this exciting suburb of Atlanta has to offer in Buckhead with the world-class shops and restaurants at Buckhead Village District, Lenox Square and Phipps Plaza within a mile of the hotel.",
      MHotelRate: null,
      MHotelURL: "https://www.hyatt.com/en-US/group-booking/ATLGH/G-WSGA",
      MHotelPicture: "uc0_hotel2755.jpg",
    },
    registrationSettings: {
      recid: 663,
      rmeetid: 2755,
      rprice1: 500.0,
      rprice2: 0.0,
      rprice3: 600.0,
      rprice4: 0.0,
      dateendregular: "2025-04-17 00:00:00",
      datebeginlate: "2025-04-18 00:00:00",
      RegTerms:
        "To transfer a registration to another person in your firm, please contact <a href=\"mailto:events@worldservicesgroup.com\">events@worldservicesgroup.com.</a> Cancellations made after 25 March 2025 and on/before 2 April 2025 will be subject to a 30% cancellation fee. Cancellations made 3 April 2025 and thereafter are subject to the total cost (100%) of the registration fee.",
      Currency: "USD",
      CancelStartDate: "2025-04-04 00:00:00",
      CancelEndDate: "2025-04-17 00:00:00",
      RefundPercent: 30,
      RegistrationMessage:
        "Thank you for registering to attend WSG Americas Meeting 2025\nPayment Pending. An email will be sent with payment information.",
      HasWaitList: 0,
      ExpirationDate: "2025-05-07",
      HasExpirationDate: 0,
    },
    meetingHosts: [
      { wsgCompaniesID: 10032, HostType: 1 },
      { wsgCompaniesID: 180, HostType: 1 },
    ],
  },
  // Event 4: WSG IBA European M&A Luncheon 2025
  {
    meetingDetails: {
      MeetingID: 2752,
      MType: "Luncheon",
      MLocation: "Loulou Restaurant",
      MAddress: "107 rue de Rivoli",
      MAddress2: null,
      MCity: "Paris",
      MState: null,
      MZip: "75001",
      MCountry: "France",
      datefrom: "2025-02-06 12:00:00",
      dateTo: "2025-02-06 14:00:00",
      MDescription:
        "Host firm Jeantet invited WSG members to the WSG Networking Luncheon. This networking event was held in conjunction with the 13th IBA European Corporate and Private M&A Conference in Paris, France, and offered great networking opportunities for WSG M&A Professionals from across the network.",
      MTitle: "WSG IBA European M&A Luncheon 2025",
      TimeZone: "(UTC +0200) Europe/Paris",
      SetupType: "Luncheon",
      Region: null,
      EventType: "In-Person",
      VenueLink: "https://www.loulou-paris.com/loulou-paris-english",
      bannerURL: "2752Banner.gif",
      BannerUpcomingURL: "2752sBanner.gif",
      BannerHomePageURL: "2752Bannerhome.gif",
      Emailbanner: "2752_emailbanner.jpg",
      OverviewTabDescription:
        "Host firm Jeantet invited WSG members to the WSG Networking Luncheon. This networking event was held in conjunction with the 13th IBA European Corporate and Private M&A Conference in Paris, France, and offered great networking opportunities for WSG M&A Professionals from across the network.",
      UpcomingEventPage: 1,
      ComingSoon: 0,
      ComingSoonMessage: "Date Coming Soon",
      LocationComingSoon: 0,
      LocationComingSoonMessage: "Location Coming Soon",
      IsHome: 1,
      IsDeleted: 0,
    },
    registrationSettings: {
      recid: 660,
      rmeetid: 2752,
      rprice1: 150.0,
      rprice2: 0.0,
      rprice3: 150.0,
      rprice4: 0.0,
      dateendregular: "2025-01-08 00:00:00",
      datebeginlate: "2025-01-09 00:00:00",
      RegTerms:
        "Cancellations made after 1 January 2025 and on/before 8 January 2025 will be subject to a 30% cancellation fee. Cancellations made 8 January 2025 and thereafter are subject to the total cost (100%) of the registrations fee. To transfer a registration to another person in your firm, please contact events@worldservicesgroup.com.",
      Currency: "USD",
      CancelStartDate: "2025-01-05 00:00:00",
      CancelEndDate: "2025-01-08 00:00:00",
      RefundPercent: 30,
      MaxEventCapacity: 50,
      RegistrationMessage:
        "Thank you for registering to attend WSG IBA European M&A Luncheon 2025\nPayment Pending. An email will be sent with payment information.",
      HasWaitList: 0,
      ExpirationDate: "2025-02-06",
      HasExpirationDate: 1,
    },
    meetingHosts: [{ wsgCompaniesID: 10277, HostType: 1 }],
  },
  // Event 5: WSG Banking & Finance Group Meeting 2025 - Europe
  {
    meetingDetails: {
      MeetingID: 2747,
      MType: "Group Meeting",
      MLocation: "Gianni & Origoni",
      MAddress: "20, Via delle Quattro Fontane",
      MAddress2: null,
      MCity: "Rome",
      MState: null,
      MZip: "00184",
      MCountry: "Italy",
      datefrom: "2025-01-30 19:30:00",
      dateTo: "2025-01-31 15:00:00",
      MDescription:
        "Host firm Gianni & Origoni welcomed members of the WSG Banking and Finance Group to attend the WSG Banking and Finance Meeting 2025 in Rome. The meeting was a great opportunity for valuable networking opportunities and discussions on important topics within the industry.",
      MTitle: "WSG Banking & Finance Group Meeting 2025 - Europe",
      TimeZone: null,
      SetupType: "Group Meeting",
      Region: null,
      EventType: "In-Person",
      VenueLink: "https://www.gop.it",
      bannerURL: null,
      BannerUpcomingURL: null,
      BannerHomePageURL: null,
      Emailbanner: "2747_emailbanner.jpg",
      OverviewTabDescription:
        "Host firm Gianni & Origoni welcomed members of the WSG Banking and Finance Group to attend the WSG Banking and Finance Meeting 2025 in Rome. The meeting was a great opportunity for valuable networking opportunities and discussions on important topics within the industry.",
      UpcomingEventPage: 1,
      ComingSoon: 0,
      ComingSoonMessage: "Date Coming Soon",
      LocationComingSoon: 0,
      LocationComingSoonMessage: "Location Coming Soon",
      IsHome: 1,
      IsDeleted: 0,
    },
    registrationSettings: {
      recid: 656,
      rmeetid: 2747,
      rprice1: 180.0,
      rprice2: 0.0,
      rprice3: 180.0,
      rprice4: 0.0,
      dateendregular: "2025-01-04 00:00:00",
      datebeginlate: "2025-01-05 00:00:00",
      RegTerms:
        "Cancellations made after 28 December 2024 and on/before 4 January 2025 will be subject to a 30% cancellation fee. Cancellations made 5 January 2025 and thereafter are subject to the total cost (100%) of the registrations fee. To transfer a registration to another person in your firm, please contact events@worldservicesgroup.com.",
      Currency: "USD",
      CancelStartDate: "2024-12-30 00:00:00",
      CancelEndDate: "2025-01-04 00:00:00",
      RefundPercent: 30,
      RegistrationMessage:
        "Thank you for registering to attend WSG Banking and Finance Meeting 2025 – Europe\nPayment Pending. An email will be sent with payment information.",
      HasWaitList: 0,
      ExpirationDate: "2025-01-30",
      HasExpirationDate: 0,
    },
    meetingHosts: [{ wsgCompaniesID: 232, HostType: 3 }],
  },
];

/** Single event: WSG European Meeting 2025 (for insert-one flow) */
export const WSGEuropeanMeeting2025Record: LegacyEventData[] = [
  LegacyEvents2025Records[1],
];

/** Single event: WSG Americas Meeting 2025 (for insert-one flow) */
export const WSGAmericasMeeting2025Record: LegacyEventData[] = [
  LegacyEvents2025Records[2],
];

/** Single event: WSG IBA European M&A Luncheon 2025 (for insert-one flow) */
export const WSGIBAEuropeanMALuncheon2025Record: LegacyEventData[] = [
  LegacyEvents2025Records[3],
];

/** Single event: WSG Banking & Finance Group Meeting 2025 - Europe (for insert-one flow) */
export const WSGBankingFinanceGroupMeeting2025EuropeRecord: LegacyEventData[] = [
  LegacyEvents2025Records[4],
];
